<div class="device-management-container">
  <div class="header">
    <h2>Device Management</h2>
    <p>Manage IP address to friendly name mappings for attendance tracking</p>
  </div>

  <!-- Add Device Button -->
  <div class="actions">
    <button mat-raised-button color="primary" (click)="showAddFormHandler()" *ngIf="!showAddForm && !showEditForm">
      <mat-icon>add</mat-icon>
      Add Device
    </button>
  </div>

  <!-- Add Device Form -->
  <mat-card *ngIf="showAddForm" class="form-card">
    <mat-card-header>
      <mat-card-title>Add New Device</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="deviceForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>IP Address</mat-label>
            <input matInput formControlName="ipAddress" placeholder="192.168.1.100">
            <mat-error *ngIf="deviceForm.get('ipAddress')?.hasError('required')">
              IP Address is required
            </mat-error>
            <mat-error *ngIf="deviceForm.get('ipAddress')?.hasError('pattern')">
              Please enter a valid IP address
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Friendly Name</mat-label>
            <input matInput formControlName="friendlyName" placeholder="Creams Tablet 1">
            <mat-error *ngIf="deviceForm.get('friendlyName')?.hasError('required')">
              Friendly Name is required
            </mat-error>
            <mat-error *ngIf="deviceForm.get('friendlyName')?.hasError('minlength')">
              Friendly Name must be at least 2 characters
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" placeholder="Optional description"></textarea>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <input matInput formControlName="location" placeholder="Office, Reception, etc.">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-checkbox formControlName="isActive">Active Device</mat-checkbox>
        </div>

        <div class="form-actions">
          <button mat-button type="button" (click)="cancelForm()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!deviceForm.valid || loading">
            <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
            Add Device
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Edit Device Form -->
  <mat-card *ngIf="showEditForm" class="form-card">
    <mat-card-header>
      <mat-card-title>Edit Device</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="deviceForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>IP Address</mat-label>
            <input matInput formControlName="ipAddress" placeholder="192.168.1.100">
            <mat-error *ngIf="deviceForm.get('ipAddress')?.hasError('required')">
              IP Address is required
            </mat-error>
            <mat-error *ngIf="deviceForm.get('ipAddress')?.hasError('pattern')">
              Please enter a valid IP address
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Friendly Name</mat-label>
            <input matInput formControlName="friendlyName" placeholder="Creams Tablet 1">
            <mat-error *ngIf="deviceForm.get('friendlyName')?.hasError('required')">
              Friendly Name is required
            </mat-error>
            <mat-error *ngIf="deviceForm.get('friendlyName')?.hasError('minlength')">
              Friendly Name must be at least 2 characters
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" placeholder="Optional description"></textarea>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <input matInput formControlName="location" placeholder="Office, Reception, etc.">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-checkbox formControlName="isActive">Active Device</mat-checkbox>
        </div>

        <div class="form-actions">
          <button mat-button type="button" (click)="cancelForm()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!deviceForm.valid || loading">
            <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
            Update Device
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Search Filter -->
  <div class="search-container" *ngIf="!showAddForm && !showEditForm">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search Devices</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search by name, IP, or location">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <!-- Devices Table -->
  <div class="table-container" *ngIf="!showAddForm && !showEditForm">
    <mat-table [dataSource]="dataSource" matSort class="devices-table">
      
      <!-- Friendly Name Column -->
      <ng-container matColumnDef="friendlyName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Device Name</mat-header-cell>
        <mat-cell *matCellDef="let device">{{ device.friendlyName }}</mat-cell>
      </ng-container>

      <!-- IP Address Column -->
      <ng-container matColumnDef="ipAddress">
        <mat-header-cell *matHeaderCellDef mat-sort-header>IP Address</mat-header-cell>
        <mat-cell *matCellDef="let device">{{ device.ipAddress }}</mat-cell>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
        <mat-cell *matCellDef="let device">{{ device.description || '-' }}</mat-cell>
      </ng-container>

      <!-- Location Column -->
      <ng-container matColumnDef="location">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
        <mat-cell *matCellDef="let device">{{ device.location || '-' }}</mat-cell>
      </ng-container>

      <!-- Active Status Column -->
      <ng-container matColumnDef="isActive">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let device">
          <mat-chip [color]="device.isActive ? 'accent' : 'warn'" selected>
            {{ device.isActive ? 'Active' : 'Inactive' }}
          </mat-chip>
        </mat-cell>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let device">
          <button mat-icon-button color="primary" (click)="showEditFormHandler(device)" matTooltip="Edit Device">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteDevice(device)" matTooltip="Delete Device">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <!-- Loading Spinner -->
    <div class="loading-container" *ngIf="loading">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading devices...</p>
    </div>

    <!-- No Data Message -->
    <div class="no-data" *ngIf="!loading && dataSource.data.length === 0">
      <mat-icon>devices</mat-icon>
      <p>No devices found. Add your first device to get started!</p>
    </div>

    <!-- Paginator -->
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div> 